if (typeof CartForm !== 'function') {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector('form');

      this.querySelectorAll('[data-js-cart-item]').forEach((item) => {
        const remove = item.querySelector('.remove');
        if (remove) {
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');
          remove.addEventListener('click', (e) => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector('.qty');
        if (qty) {
          qty.addEventListener(
            'input',
            debounce((e) => {
              e.preventDefault();
              e.target.blur();
              let newQty = parseInt(qty.value);
              if (qty.max && newQty > parseInt(qty.max)) newQty = parseInt(qty.max);
              this.updateCartQty(item, newQty);
            }, 500)
          );
          qty.addEventListener('click', (e) => {
            e.target.select();
          });
        }
      });
    }

    updateCartQty(item, newQty) {
      let alert = null;

      this.form.classList.add('processing');
      if (this.querySelector('.alert')) {
        this.querySelector('.alert').remove();
      }

      // A product page gift wrap line always follows the quantity of its main line
      const giftWrapKey = item.dataset.giftWrapKey;

      const body = giftWrapKey
        ? JSON.stringify({ updates: { [item.dataset.id]: newQty, [giftWrapKey]: newQty } })
        : JSON.stringify({
            line: parseInt(item.dataset.line),
            quantity: newQty,
          });

      fetch(giftWrapKey ? `${KROWN.settings.routes.cart_update_url}.js` : KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (!giftWrapKey || response.status == 422 || !response.items) return response;
          // Stock limits can cap the main line, so bring the gift wrap line back in step
          const main = response.items.find((line) => line.key == item.dataset.id);
          const wrap = response.items.find((line) => line.key == giftWrapKey);
          if (!main || !wrap || main.quantity == wrap.quantity) return response;
          return fetch(`${KROWN.settings.routes.cart_update_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({ updates: { [giftWrapKey]: main.quantity } }),
          }).then((response) => response.json());
        })
        .then((response) => {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            if (typeof response.description === 'string') {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
          }
          return fetch('?section_id=helper-cart');
        })
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
          const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
          const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

          const cartItems = document.getElementById('AjaxCartForm');
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
            elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
          });
          document.querySelectorAll('[data-header-cart-total').forEach((elm) => {
            elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
          });

          if (alert !== null) {
            this.form.prepend(alert);
          }

          document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

          const event = new Event('cart-updated');
          this.dispatchEvent(event);
        })
        .catch((e) => {
          console.log(e);
          let alert = document.createElement('span');
          alert.classList.add('alert', 'alert--error');
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => {
          this.form.classList.remove('processing');
        });
    }
  }

  if (typeof customElements.get('cart-form') == 'undefined') {
    customElements.define('cart-form', CartForm);
  }
}

if (typeof CartProductQuantity !== 'function') {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
      this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
    }
    changeCartInput() {
      setTimeout(() => {
        document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
      }, 50);
    }
  }

  if (typeof customElements.get('cart-product-quantity') == 'undefined') {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}

// method for apps to tap into and refresh the cart

if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch('?section_id=helper-cart')
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
          elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
        });
        document.querySelectorAll('[data-header-cart-total').forEach((elm) => {
          elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
        });

        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
        if (document.querySelector('[data-js-site-cart-sidebar]')) {
          document.querySelector('[data-js-site-cart-sidebar]').show();
        }

        if (document.querySelector('cart-recommendations')) {
          document.querySelector('cart-recommendations').innerHTML = '';
          document.querySelector('cart-recommendations').generateRecommendations();
        }
      });
  };
}

if (typeof CartProgressBar !== 'function') {
  class CartProgressBar extends HTMLElement {
    connectedCallback() {
      const cfg = window.cartProgressBar;
      if (!cfg) return;
      if (cfg.enabled === false) {
        this.style.display = 'none';
        return;
      }

      // Markets without their own milestones get the shop currency amounts converted to the cart currency
      const rate = cfg.convert && window.Shopify && Shopify.currency ? parseFloat(Shopify.currency.rate) || 1 : 1;

      const count = parseInt(cfg.stepsCount) || 3;
      const currency = cfg.currency || 'kr';
      const activeSteps = cfg.steps
        .slice(0, count)
        .filter((s) => s.amount > 0)
        .map((s) => ({ ...s, amount: Math.ceil(s.amount * rate) }))
        .sort((a, b) => a.amount - b.amount);
      if (!activeSteps.length) return;

      const total = parseInt(this.dataset.cartTotal) || 0;
      const max = activeSteps[activeSteps.length - 1].amount * 100;

      const track = this.querySelector('.cart-progress-bar__track');
      if (!track) return;

      const fill = track.querySelector('.cart-progress-bar__fill');
      if (fill) fill.style.width = Math.min((total / max) * 100, 100) + '%';

      track.querySelectorAll('.cart-progress-bar__node').forEach((n) => n.remove());

      const dot = `<div class="cart-progress-bar__dot"><svg viewBox="0 0 10 8" fill="none" aria-hidden="true"><path d="M1 4L3.5 6.5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>`;

      const startNode = document.createElement('div');
      startNode.className = `cart-progress-bar__node cart-progress-bar__node--start${total >= 1 ? ' cart-progress-bar__node--done' : ''}`;
      startNode.innerHTML = `${dot}<span class="cart-progress-bar__label">0 ${currency}</span>`;
      track.appendChild(startNode);

      activeSteps.forEach((step, i) => {
        const isEnd = i === activeSteps.length - 1;
        const isDone = total >= step.amount * 100;
        const node = document.createElement('div');
        node.className = `cart-progress-bar__node${isEnd ? ' cart-progress-bar__node--end' : ''}${isDone ? ' cart-progress-bar__node--done' : ''}`;
        if (!isEnd) {
          node.style.setProperty('--node-pos', (((step.amount * 100) / max) * 100).toFixed(2) + '%');
        }
        node.innerHTML = `${dot}<span class="cart-progress-bar__label"><strong>${isEnd ? '+' : ''}${step.amount} ${currency}</strong>${step.label ? step.label : ''}</span>`;
        track.appendChild(node);
      });
    }
  }

  if (typeof customElements.get('cart-progress-bar') === 'undefined') {
    customElements.define('cart-progress-bar', CartProgressBar);
  }
}
